export default __webpack_public_path__ + "static/media/main.a6e2122b.jpg";